<template>
    <title>Vestel Serial Number Converter</title>
    <h1>ASWO Vestel Serial Number Converter</h1>




    <h2>Washing machines</h2>

    <h4>Vestel serial numbers for Washing machines consist of 20 digits.

        The first 8 digits correspond to the product code/ID number of the device and the further 8 digits of the ORDER
        NUMBER.

        You identify the PRODUCTION ORDER NUMBER by placing an 53 in front of the ORDER NUMBER.

        With the PRODUCTION ORDER NUMBER, your device is 100% assigned to a production and the associated spare parts
        list.

        You can also enter the complete serial number in the next field, we are looking for the right device for you.



    </h4>
    <h3>Example of SN : 00613120000317840012</h3>
    <div class="grow mx1">
        <w-select class="xs8 pa0" v-model="Lookup.appliance" :items="Lookup.type" outline return-object>Select An
            Appliance</w-select>
        <w-input v-model="Lookup.search">SN :</w-input>
        <div id="device">
            <w-button class="ma1" bg-color="success" color="yellow-light2" @click="getCode()">
                Get Code
            </w-button>
        </div>
        {{ Lookup.OrderNumber }}
    </div>
</template>
<script>
import { ref } from "vue";

export default {
    name: "Vestel",

    data() {
        const Lookup = ref({
            search: "",
            appliance: [],
            type: [
                { label: "Dishwasher", value: '55' },
                { label: "Cooker", value: '54' },
                { label: "Washing Machine", value: '53' },
                { label: "Tumble Dryer", value: '57' },
                { label: "Refrigeration", value: '51' }
            ],
            OrderNumber: "",
            ProductCode: "",
            SerialNumber: ""



        })
        const type = {
            Dishwasher: '55',
            Cooker: '54',
            WashingMachine: '53',
            TumbleDryer: '57',
            Refrigeration: '51'
        }
        function Vestel(typeNumber, sn) {
            console.log(sn.length);
            if (sn.length == 20 && typeNumber != '51') {
                let [OrderNumber, ProductCode, SerialNumber] = [typeNumber + sn.slice(8, 16), sn.slice(1, 8), sn.slice(16, 20)]
                return { OrderNumber, ProductCode, SerialNumber }
            }
            if (sn.length == 22 && typeNumber == '51') {
                let [OrderNumber, ProductCode, SerialNumber] = [typeNumber + sn.slice(10, 18), sn.slice(0, 8), sn.slice(18, 22)]
                return { OrderNumber, ProductCode, SerialNumber }
            } else {
                return { OrderNumber: `Serial Number ${sn} Is Incorrect Please Retry or Wrong Type for Serial Number` }
            }
        }

        function getCode() {
            console.log(Lookup.value.appliance.value);
            console.log(Lookup.value.search);

            // document.getElementById('device').innerHTML = '<h1>' + Vestel(type[types], input).OrderNumber + '</h1>'
            [Lookup.value.OrderNumber,
            Lookup.value.ProductCode,
            Lookup.value.SerialNumber] = [Vestel(Lookup.value.appliance.value, Lookup.value.search)]
        }
        return { Lookup, getCode }
    }
}
</script>

